module.exports = __webpack_public_path__ + "img/申请查询服务退款.182b6b4b.png";